@if (ready()) {
    <div class="bar">
        <cl-icon [icon]="icons.Info" class="icon" />
        <span>{{ 'update-notifier.message' | translate }}</span>
        <app-button size="small" (click)="reload()">{{ 'update-notifier.reload' | translate }}</app-button>
    </div>
}
